<div class="image-viewer">
  <div class="image-viewer-toolbar" *ngIf="objectUrl">
    <button pButton pRipple type="button"
            icon="fa-solid fa-rotate-right"
            class="p-button-rounded p-button-text"
            (click)="rotate()"
            pTooltip="Girar 90°"
            tooltipPosition="bottom">
    </button>
  </div>
  <div class="image-viewer-stage">
    <img *ngIf="objectUrl"
         [src]="objectUrl"
         [style.transform]="'rotate(' + rotation + 'deg)'"
         alt="Imagen previsualizada" />
  </div>
</div>
